import { createAsyncThunk } from "@reduxjs/toolkit"
import { baseURL, requestUrl } from "../../../Utils/baseUrls"
import { AxiosResponse } from "axios"
import { APIResponse, AxioMethodType } from "../../../Utils/Const"
import { user_mstr_modal } from "./types"


// accountGone: the account was deleted/deactivated or the session is no longer valid, so the user must be logged out.
// This loads the logged-in user's own record, so any client error means the session's user is unusable
// (a user missing from the DB comes back as HTTP 400 "Object reference not set..."). Temporary errors
// (timeout, rate limit, 5xx, network) are not accountGone: they shouldn't log anyone out.
export type UserDetailsError = { message: string; accountGone: boolean };
const isAccountGoneStatus = (status: unknown) => {
    const code = Number(status);
    return code >= 400 && code < 500 && code !== 408 && code !== 429;
};

export const getUserDetails = createAsyncThunk<user_mstr_modal, string, { rejectValue: UserDetailsError }>(
    "user/getUser",
    async (userid, { rejectWithValue }) => {
        try {
            const res = await baseURL.get(`${requestUrl.users}/${userid}`);

            if (res.data.code === "200") {
                const user = res.data.responseData as user_mstr_modal | null;
                if (!user || user.activestatus === false) {
                    return rejectWithValue({ message: "This account is no longer active.", accountGone: true });
                }
                return user;
            }

            return rejectWithValue({
                message: res.data.message ?? "Failed to fetch user details",
                accountGone: isAccountGoneStatus(res.data.code),
            });
        } catch (error: any) {
            return rejectWithValue({
                message: error?.response?.data?.message ?? error?.message ?? "Something went wrong",
                accountGone: isAccountGoneStatus(error?.response?.status),
            });
        }
    }
);
export const UserDetailsAction = createAsyncThunk("user/handle", async ({ reqBody, userid }: { reqBody: any, userid?: string }, { rejectWithValue }) => {
    try {
        let method: AxioMethodType = "post", url = requestUrl.users
        if (userid) {
            method = "put";
            url = url + "/" + userid
        };
        const { data }: AxiosResponse<APIResponse<user_mstr_modal>> = await baseURL[method](url, reqBody);
        if (data.code !== "200") {
            throw new Error("Something went wrong");
        }
        return data.responseData;
    } catch (err: any) {
        return rejectWithValue(err);
    }
})



